import React from 'react';
import styles from "./Experties.module.css";
import img1 from "./Frame1.jpg";
import img2 from "./Frame2.avif";
import img3 from "./Frame3.jpeg";


// Component for displaying the Experties section
import { InfoCard } from './InfoCard';
const Titles = [
    "Energy Efficient Chips",
    "Innovative AI Hardware Solutions",
    "Custom AI Design Services"
];
const Details = [
    "Designed for optimal performance while minimizing power consumption.",
    "Leading the industry with cutting-edge AI acceleration technology.",
    "Tailored solutions to meet the unique needs of your AI applications."

]
const Experties = () => {
    return (
        <div className={styles.container}>
            <div className={styles.heading}>
                <h1 className={styles.title}>Our Specializations</h1>
            </div>
            <div className={styles.experties}>
                <div className={styles.box}>
                    <InfoCard title={Titles[0]} Detail={Details[0]} color="rgba(255, 74, 61, 1)" img={img1} />


                </div>
                <div className={styles.box}>
                    <InfoCard title={Titles[1]} Detail={Details[1]} color="#01a89aa9" img={img2} />
                </div>
                <div className={styles.box}>
                    <InfoCard title={Titles[2]} Detail={Details[2]} color="#3885ffff" img={img3} />
                </div>

            </div>

        </div>
    )
}

export default Experties